export const config = {
  auth: {
    authority: "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_Mv8ptOpkp",
    clientId: "ane7n7ga1f8a4rpgngk7cmejb",
    redirectUri: "https://devx-chatbot.saas-sltc-sandbox-dev.dht.live",
    postLogoutRedirectUri: "https://devx-chatbot.saas-sltc-sandbox-dev.dht.live",
    cognitoDomain: "https://us-west-2mv8ptopkp.auth.us-west-2.amazoncognito.com",
  },
  api: {
    ragChatEndpoint: "https://yg0q2006qd.execute-api.us-west-2.amazonaws.com/prod/chat/rag",
    vectorStoreId: "vs_67e2093e182881919c1439b61c364e54",
  },
};
